import './uppertext.css'

function uppertext(props) {
  return (
    <div className="uppertext">
        <h2>{props.text}</h2>
    </div>
  );
}
export default uppertext;